import React, { Component, Fragment } from 'react'
import CustomAlert from '../../components/shared/CustomAlert'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import AgentNotes from '../../components/agents/AgentNotes/AgentNotes.component'
import AgentPushMessage from '../../components/push/AgentPushMessage'
import AgentHeadshotUploader from '../../components/agents/AgentHeadshotUploader/AgentHeadshotUploader.component'
import ResetEnrollmentButton from './components/ResetEnrollmentButton/ResetEnrollmentButton.component'
import ResyncCorporateEmailButton from './components/ResyncCorporateEmailButton/ResyncCorporateEmailButton.component'
import ResetUplineSignatureButton from './components/ResetUplineSignatureButton/ResetUplineSignatureButton.component'
import RequiredTrainingChart from './components/RequiredTrainingChart/RequiredTrainingChart.component'
import AddAdminFeeWaiverButton from './components/AddAdminFeeWaiverButton/AddAdminFeeWaiverButton.component'
import HasOnboardedToggleSwitch from './components/HasOnboardedToggleSwitch/HasOnboardedToggleSwitch.component'
import IsTeamRecruiterToggleSwitch from './components/IsTeamRecruiterToggleSwitch/IsTeamRecruiterToggleSwitch.component'
import UpdatePaymentToggleSwitch from './components/UpdatePaymentToggleSwitch/UpdatePaymentToggleSwitch.component'
import { ChangeRequestButton } from './components/HierarchyChangeRequest'
import UserActiveButton from './components/UserActiveButton/UserActiveButton.component'
import { ViewAwardButton } from './components/ViewAwardButton/ViewAwardButton.component'
import AgentOptions from './components/AgentOptions/AgentOptions.component'
import AgentRequirements from './components/AgentRequirements/AgentRequirements.component'
import StorageService from './../../shared/services/Storage.service'
import {
  MDBCard,
  MDBCardBody,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBBtn,
  MDBListGroup,
  MDBListGroupItem,
  MDBSelect,
  MDBInput,
  MDBCardHeader,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalBody,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import placeholder_picture from '../../assets/images/user_placeholder.png'
import { toast } from 'react-toastify'
import appConstants from '../../constants/appConstants'
import AdminApi from '../../api/admin-api/admin-api'
import moment from 'moment'
import AgentTerms from './../../components/agents/AgentTerms/AgentTerms.component'
import ToolTip from './../../components/shared/ToolTip/ToolTip.component'
import { UIDatePickerInput, UISelect } from './../../components/forms/form-fields'
import 'react-datepicker/dist/react-datepicker.css'
import AgentCorporateEmailLink from './components/AgentCorporateEmailLink/AgentCorporateEmailLink.component'
import UserProfileService from './../../shared/services/UserProfile.service'
import UploadService from './../../shared/services/Upload.service'
import { phoneToStorage, phoneToView } from './../../shared/formatters/telephone.formatter'
import { phone as phonePattern } from './../../shared/patterns/telephone.pattern'
import { email as emailPattern } from './../../shared/patterns/email.pattern'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import { UIInput } from './../../components/forms/form-fields'

// import UserAlertsStore from '../../components/users/UserAlertsIndicator/UserAlerts.store'
import UserUserTypesService from '../../shared/services/UserUserTypes.service'
import UsertypeService from '../../shared/services/Usertype.service'
import { invalidMarketingTitles } from '../../constants/invalidMarketingTitles'
import { ResendEmailButton } from './components/ResendEmailButton/ResendEmailButton.component'
import UserContractCartFactory from './../../shared/factories/user-contract-cart.factory'
import SupportEmailsModal from './../../components/modals/SupportEmailsModal/SupportEmailsModal.component'
import RecruitingPermissionToggle from './components/RecruitingPermissionToggle/RecruitingPermissionToggle.component'
import LegalNameChangeModal from './components/LegalNameChangeModal/LegalNameChangeModal.component'
import { isWhiteLabel } from './../../shared/utilities/whiteLabel.function'

import './AccountProfilePage.scss'

const localUserData = StorageService.get('user_details')

const timezones = (appConstants.Timezone || []).map(t => {
  return { text: t.name, value: t.id }
})
const states = (appConstants.States || []).map(t => {
  return { text: t.name, value: t.id }
})
const spokenLanguages = (appConstants.spoken_languages || []).map(t => {
  return { text: t, value: t }
})

const getIsUsertypePaid = uId => {
  return appConstants.paid_subscriptions.includes(uId) === true
    ? 'paid'
    : appConstants.unpaid_subscriptions.includes(uId)
    ? 'unpaid'
    : ''
}

class AccountProfile extends Component {
  _isAdminUser = UserProfileService.isA(['system-admin', 'agency-owner'], true)
  _isBSTAdmin = UserProfileService.isA(['internal-admin'], true)
  _isStaffUser = UserProfileService.isA(['system-admin', 'agency-owner', 'internal-staff', 'internal-admin'], true)
  // BST only — narrower than _isStaffUser (excludes agency-owner). ignoreAssumed
  // is REQUIRED: this page is reached by ASSUMING the agent, so without it the
  // check would read the agent's usertype instead of the admin's.
  _canSendPush = UserProfileService.isA(['internal-admin', 'internal-staff', 'system-admin'], true)
  _isLeaderOrAssitUser = UserProfileService.isA(
    ['district-leader', 'regional-leader', 'divisional-leader', 'division-admin', 'region-admin', 'district-admin'],
    true
  )
  _isAssumedUser = UserProfileService.isAssumed()
  _canSetUpline = this._isAssumedUser && this._isStaffUser

  maxDob = moment().subtract(18, 'years').toDate()

  state = {
    prefix: '',
    suffix: '',
    loading: false,
    submitting: false,
    formError: false,
    errorMessage: '',
    timezones: timezones,
    states: states,
    spokenLanguages: spokenLanguages,
    recruiters: [],
    userData: {},
    clonedUserData: {},
    notesHistoryList: [],
    profile_pic: '',
    userRoles: {},
    urlParams: {},
    userTypeList: [],
    userTypes: [],
    commissionLevelList: [],
    commissionLevels: [],
    divisionsList: [],
    divisions: [],
    uplineUsersList: [],
    uplineUsers: [],
    userTermsModal: false,
    legalNameModal: false,
    isReadOnly: false,
    permittedAttribs: [],
    permitChangeUsertype: null,
    enableChangeUsertype: null,
    prevMarketingTitle: '',
    activeTab: 'my-profile',
    Cart: null,
    divisionAutoSetFromUpline: false,
    divisionSyncing: false,
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props
    this.setState({ urlParams: params }, this.fetchDependencies)

    // Call the cart fetching function if user is leader or assistant
    if (this._isLeaderOrAssitUser) this.fetchUserContractCart()
  }

  fetchUserContractCart = async () => {
    try {
      let cart = await UserContractCartFactory.findOpenByUserId(UserProfileService.getUserId())
      // If no open cart, try to find active cart
      if (!cart) {
        cart = await UserContractCartFactory.findActiveByUserId(UserProfileService.getUserId())
      }
      this.setState({ Cart: cart }) // Store cart in state
    } catch (ex) {
      console.error(`Failed to fetch user contracting cart. ex: ${ex}`)
      this.setState({ Cart: null })
    }
  }

  _toggleUserTermsModal = () => this.setState({ userTermsModal: !this.state.userTermsModal })

  _confirmLegalNameChange = () => {
    this.setState({ legalNameModal: false })
    this.handleUpdate(true)
  }

  _cancelLegalNameChange = () => {
    this.setState(prevState => ({
      legalNameModal: false,
      userData: {
        ...prevState.userData,
        u_fname: prevState.clonedUserData.u_fname,
        u_lname: prevState.clonedUserData.u_lname,
      },
    }))
  }

  _renderRecruitingPermissionToggle = () => (
    <RecruitingPermissionToggle userId={this.state.urlParams?.id || UserProfileService.getUserId()} />
  )

  //Change event for input fields
  onChange = (event, format) => {
    let value = event.target.value
    switch (format) {
      case 'phone':
        value = value ? phoneToView(value) : value
        break
      default:
        break
    }

    this.setState(prevState => {
      let userData = Object.assign({}, prevState.userData)
      userData[event.target.name] = value
      return { userData }
    })
  }

  onDateChange = value => {
    this.setState(prevState => {
      let userData = Object.assign({}, prevState.userData)
      userData['u_birthday'] = value
      return { userData }
    })
  }

  onTimezoneChange = value => {
    this.setState(prevState => {
      let userData = Object.assign({}, prevState.userData)
      userData['u_timezone'] = value
      return { userData }
    })
  }

  onStatesChange = value => {
    this.setState(prevState => {
      let userData = Object.assign({}, prevState.userData)
      userData['u_state'] = value
      return { userData }
    })
  }

  onRecruiterChange = value => {
    this.setState(prevState => {
      let userData = Object.assign({}, prevState.userData)
      userData['recruited_by'] = value
      return { userData }
    })
  }

  onSpokenLanguageChange = value => {
    this.setState(prevState => {
      let userData = Object.assign({}, prevState.userData)
      userData['u_spoken_language'] = value
      return { userData }
    })
  }

  onUserTypeChange = value => {
    this.setState(prevState => {
      let userData = Object.assign({}, prevState.userData)
      userData['usertype_id'] = value
      return { userData }
    })

    if (parseInt(value) === appConstants.career_agent) {
      this.setState(prevState => {
        let userData = Object.assign({}, prevState.userData)
        userData['u_marketing_title'] = 'Insurance Agent'
        return {
          userData,
          prevMarketingTitle: prevState.userData['u_marketing_title'],
        }
      })
    } else {
      this.setState(prevState => {
        let userData = Object.assign({}, prevState.userData)
        if (userData['u_marketing_title'] === 'Insurance Agent')
          userData['u_marketing_title'] = prevState.prevMarketingTitle
        return { userData }
      })
    }
  }

  onCommissionLevelChange = value => {
    this.setState(prevState => {
      let userData = Object.assign({}, prevState.userData)
      userData['commission_id'] = value
      return { userData }
    })
  }

  onDivisionChange = value => {
    this.setState(prevState => {
      let userData = Object.assign({}, prevState.userData)
      userData['u_devision'] = value
      return { userData, divisionAutoSetFromUpline: false }
    })
  }

  onUplineChange = value => {
    this.setState(
      prevState => {
        let userData = Object.assign({}, prevState.userData)
        userData['u_upline_id'] = value
        return { userData, divisionSyncing: true }
      },
      () => this.syncDivisionFromUpline(value)
    )
  }

  syncDivisionFromUpline = async uplineId => {
    const userId = this.state.userRoles?.id

    if (!userId || !uplineId) return this.setState({ divisionSyncing: false })

    let divisionSync = null
    try {
      divisionSync = (await AdminApi.getUplineDivisionPreview(userId, uplineId, this.state.userData['u_devision']))
        ?.data?.data
    } catch (ex) {
      divisionSync = null
    }

    if (!divisionSync || !divisionSync.to) return this.setState({ divisionSyncing: false })

    this.setState(
      prevState => {
        if (`${prevState.userData['u_upline_id']}` !== `${uplineId}`) return { divisionSyncing: false }

        let userData = Object.assign({}, prevState.userData)
        userData['u_devision'] = `${divisionSync.to}`

        return {
          userData,
          divisions: (prevState.divisions || []).map(item => ({
            ...item,
            checked: `${item.value}` === `${divisionSync.to}`,
          })),
          divisionCurrentValue: divisionSync.name,
          divisionSyncing: false,
          divisionAutoSetFromUpline: true,
        }
      },
      () => {
        toast.info(
          `Division changed to ${divisionSync.name} to match the new upline leader. Click "Save Profile" to apply this change.`,
          { position: toast.POSITION.TOP_RIGHT, autoClose: 10000 }
        )
        this.reloadRecruiters(uplineId, divisionSync.to)
      }
    )
  }

  /*onFileChange = value => {
        this.setState({profile_pic: value})
    }*/

  fetchDependencies = async () => {
    this.setState({ loading: true })

    Promise.all([this.fetchUplineUsers(), this.fetchDivisions(), this.fetchCommissionLevels(), this.fetchUserTypes()])
      .then(results => {
        let stateUpd = {}
        results.forEach(result => {
          if (typeof result === 'object') stateUpd = { ...stateUpd, ...result }
        })

        this.setState(stateUpd)
        this._fetchCurrentUserdata().finally(() => this.setState({ loading: false }))
      })
      .catch(() => this.setState({ loading: false }))
  }

  fetchUserTypes = async () => {
    try {
      return { userTypeList: (await AdminApi.getUserTypes())?.data?.data || [] }
    } catch (ex) {
      return { userTypeList: [] }
    }
  }

  fetchCommissionLevels = async () => {
    try {
      return {
        commissionLevelList: (await AdminApi.getCommissions())?.data?.data || [],
      }
    } catch (ex) {
      return { commissionLevelList: [] }
    }
  }

  fetchDivisions = async () => {
    try {
      return {
        divisionsList: (await AdminApi.getDivisions())?.data?.data || [],
      }
    } catch (ex) {
      return { divisionsList: [] }
    }
  }

  fetchUplineUsers = async () => {
    try {
      return {
        uplineUsersList: ((await AdminApi.getAllUplineUsers())?.data?.data || []).sort((a, b) =>
          a?.u_name > b?.u_name ? 1 : a?.u_name < b?.u_name ? -1 : 0
        ),
      }
    } catch (ex) {
      return { uplineUsersList: [] }
    }
  }

  fetchRecruiters = async (userId, divisionId, includeId) => {
    try {
      return (await AdminApi.getAllRecruitersByDivisionId(divisionId, includeId))?.data?.data || []
    } catch (ex) {
      return []
    }
  }

  buildRecruiterOptions = (recruiters, recruitedBy) =>
    recruiters
      .filter(item => parseInt(item.u_active) === 1 || parseInt(item.id) === parseInt(recruitedBy))
      .map(item => {
        if (parseInt(item.id) === parseInt(recruitedBy))
          this.setState({
            recruiterCurrentValue: item.u_fname + ' ' + item.u_lname,
          })
        return {
          text: item.u_fname + ' ' + item.u_lname,
          value: `${item.id}`,
          checked: parseInt(item.id) === parseInt(recruitedBy),
        }
      })

  reloadRecruiters = async (uplineId, divisionId) => {
    const recruitedBy = this.state.userData['recruited_by']
    const recruiters = this.buildRecruiterOptions(
      await this.fetchRecruiters(uplineId, divisionId, recruitedBy),
      recruitedBy
    )

    this.setState(prevState => (`${prevState.userData['u_upline_id']}` === `${uplineId}` ? { recruiters } : null))
  }

  _canViewHistory = () => {
    if (UserProfileService.isA(['agency-owner', 'internal-admin', 'internal-staff', 'system-admin'], true)) return true

    // recruiter is seperated incase we want to limit per-agent access.
    if (UserProfileService.isA(['recruiter-group'], true)) return true

    return false
  }

  _isPermitted = attrib =>
    !this.state.isReadOnly ||
    (Array.isArray(this.state.permittedAttribs) ? this.state.permittedAttribs.includes(attrib) : false)

  _loadProfile = (userData, permittedAttribs, imageUrl, enableChangeUsertype) => {
    const isPermitted = attrib =>
        permittedAttribs === true ? true : Array.isArray(permittedAttribs) && permittedAttribs.includes(attrib),
      isReadOnly = permittedAttribs !== true

    let clonedUserData = {},
      notesHistoryList = [],
      stateUpd = {
        isReadOnly,
        permittedAttribs: Array.isArray(permittedAttribs) ? permittedAttribs : [],
      }

    if (parseInt(userData['usertype_id']) === appConstants.career_agent)
      userData['u_marketing_title'] = 'Insurance Agent'

    // Clone the initial user data payload.
    clonedUserData = JSON.parse(JSON.stringify(userData))

    // Build the Usertype & Commission Level change history.
    // Limited by public access.
    notesHistoryList = this._buildUserHistoryList(
      isPermitted('usertype_history') ? userData.usertypes_history : '',
      isPermitted('commission_history') ? userData.commission_history : '',
      permittedAttribs === true ? true : 1
    )

    stateUpd.timezones = this.state.timezones

    if (isPermitted('u_timezone'))
      stateUpd.timezones = stateUpd.timezones.map(item => ({
        ...item,
        checked: item.value === userData.u_timezone,
      }))
    if (isPermitted('u_state'))
      stateUpd.states = this.state.states.map(item => ({
        ...item,
        checked: item.value === userData.u_state,
      }))

    if (isPermitted('recruited_by'))
      stateUpd.recruiters = this.state.recruiters.map(item => ({
        ...item,
        checked: parseInt(item.value) === parseInt(userData.recruited_by),
      }))

    if (isPermitted('u_birthday')) {
      if (userData.u_birthday && typeof userData.u_birthday === 'string') {
        if (!isNaN(Date.parse(userData.u_birthday.split(/T|\s/).shift()))) {
          clonedUserData.u_birthday = moment(userData.u_birthday.split(/T|\s/).shift()).toDate()
          userData.u_birthday = moment(userData.u_birthday.split(/T|\s/).shift()).toDate()
        } else {
          clonedUserData.u_birthday = userData.u_birthday
        }
      }
    }

    if (isPermitted('u_enrolled')) {
      if (userData.u_enrolled && typeof userData.u_enrolled === 'string') {
        userData.u_enrolled = userData.u_enrolled.split(/T|\s/).shift()
        clonedUserData.u_enrolled = userData.u_enrolled
      }
    }

    if (isPermitted('u_spoken_language')) {
      if (!userData.u_spoken_language) userData.u_spoken_language = []
      if (userData.u_spoken_language && typeof userData.u_spoken_language === 'string') {
        userData.u_spoken_language = JSON.parse(userData.u_spoken_language)
        clonedUserData.u_spoken_language = userData.u_spoken_language
      }
      if (userData.u_spoken_language) {
        this.setState(prev => {
          return {
            ...prev,
            spokenLanguages: spokenLanguages.map(lang => {
              return {
                ...lang,
                checked: userData.u_spoken_language.includes(lang.value),
              }
            }),
          }
        })
      }
    }

    // Main User profile data objects.
    stateUpd.userData = userData
    stateUpd.notesHistoryList = notesHistoryList
    stateUpd.clonedUserData = clonedUserData
    stateUpd.prefix = imageUrl.prefix
    stateUpd.suffix = imageUrl.suffix
    stateUpd.enableChangeUsertype = enableChangeUsertype

    // Agent Phones
    stateUpd.userData.u_phone = isPermitted('u_phone') ? phoneToView(stateUpd.userData.u_phone || '') : ''
    stateUpd.userData.u_fax = isPermitted('u_fax') ? phoneToView(stateUpd.userData.u_fax || '') : ''
    stateUpd.userData.u_mobile = isPermitted('u_mobile') ? phoneToView(stateUpd.userData.u_mobile || '') : ''
    stateUpd.userData.u_tollfree = isPermitted('u_tollfree') ? phoneToView(stateUpd.userData.u_tollfree || '') : ''

    // Selectable dropdowns are locked when readonly
    if (!isReadOnly) {
      stateUpd.userTypes = this.state.userTypeList
        .map(item => {
          // 1. Identify the current usertype label/name.
          if (parseInt(item.id) === parseInt(stateUpd.userData['usertype_id']))
            stateUpd.userTypeCurrentValue = item.displayname

          // 2. Create dropdown item from usertype record.
          item = {
            text: item.displayname,
            value: `${item.id}`,
            checked: parseInt(item.id) === parseInt(stateUpd.userData['usertype_id']),
          }

          // 3. Permit the agent's current usertype into the dropdown list.
          if (parseInt(stateUpd.userData['usertype_id']) === parseInt(item.value)) return item

          // 4. Confirm the selectable usertypes are of a matching
          // paid/unpaid subscription status to the current agent's usertype.
          if (getIsUsertypePaid(parseInt(item.value)) !== getIsUsertypePaid(parseInt(stateUpd.userData['usertype_id'])))
            return false

          // 5. Permit all options if logged in user is an admin?
          if (this._isAdminUser || this._isBSTAdmin) {
            if (UserProfileService.isA(['system-admin'], true)) return item
            if (UserProfileService.isA(['agency-owner'], true))
              return !['system-admin'].includes(UsertypeService.idToName(item.value)) ? item : false
            return !['system-admin', 'agency-owner'].includes(UsertypeService.idToName(item.value)) ? item : false
          }

          // 6. If the current user does not have access to change
          // usertypes, stop the filter here.  Do not return any
          // other usertypes.
          if (!enableChangeUsertype) return false

          // 7. If we're viewing an admin's account, deny all usertype options.
          if ([35, 219].indexOf(parseInt(stateUpd.userData['usertype_id'])) > -1) return false

          // 8. If logged in user is staff, block them from elevated usertypes.
          if (this._isStaffUser) {
            if ([35, 219].indexOf(parseInt(item.value)) > -1) return false
            return item
          }

          // 9. If the logged in user is an assumed account, limit
          // usertype options.  The only option to add here
          // is limited to training / limited to contracting.
          if (this._isAssumedUser) {
            if ([91, 149].indexOf(parseInt(stateUpd.userData['usertype_id'])) > -1)
              if ([91, 149].indexOf(parseInt(item.value)) > -1) return item
          }

          return false
        })
        .filter(u => u)

      stateUpd.commissionLevels = this.state.commissionLevelList.map(item => {
        if (parseInt(item.id) === parseInt(stateUpd.userData['commission_id']))
          this.setState({ commissionLevelCurrentValue: item.com_name })
        return {
          text: item.com_name,
          value: `${item.id}`,
          checked: parseInt(item.id) === parseInt(stateUpd.userData['commission_id']),
        }
      })

      stateUpd.divisions = this.state.divisionsList.map(item => {
        if (parseInt(item.id) === parseInt(stateUpd.userData['u_devision']))
          this.setState({ divisionCurrentValue: item.d_name })
        return {
          text: item.d_name,
          value: `${item.id}`,
          checked: parseInt(item.id) === parseInt(stateUpd.userData['u_devision']),
        }
      })

      stateUpd.uplineUsers = this.state.uplineUsersList.map(item => {
        if (parseInt(item.id) === parseInt(stateUpd.userData['u_upline_id']))
          this.setState({ uplineCurrentValue: item.u_name })
        return {
          text: item.u_name,
          value: `${item.id}`,
          checked: parseInt(item.id) === parseInt(stateUpd.userData['u_upline_id']),
        }
      })
    } else {
      stateUpd.userTypes = []
      if (isPermitted('usertype_id')) {
        stateUpd.userTypes = this.state.userTypeList
          .filter(item => parseInt(item.id) === parseInt(stateUpd.userData['usertype_id']))
          .map(item => {
            // 1. Identify the current usertype label/name.
            stateUpd.userTypeCurrentValue = item.displayname

            // 2. Create dropdown item from usertype record.
            return {
              text: item.displayname,
              value: `${item.id}`,
              checked: true,
            }
          })
      }

      stateUpd.commissionLevels = []
      if (isPermitted('commission_id')) {
        stateUpd.commissionLevels = this.state.commissionLevelList
          .filter(item => parseInt(item.id) === parseInt(stateUpd.userData['commission_id']))
          .map(item => {
            // 1. Identify the current usertype label/name.
            stateUpd.commissionLevelCurrentValue = item.com_name

            // 2. Create dropdown item from commission record.
            return {
              text: item.com_name,
              value: `${item.id}`,
              checked: true,
            }
          })
      }

      stateUpd.divisions = []
      if (isPermitted('u_devision')) {
        stateUpd.divisions = this.state.divisionsList
          .filter(item => parseInt(item.id) === parseInt(stateUpd.userData['u_devision']))
          .map(item => {
            // 1. Identify the current division label/name.
            stateUpd.divisionCurrentValue = item.d_name

            // 2. Create dropdown item from division record.
            return {
              text: item.d_name,
              value: `${item.id}`,
              checked: true,
            }
          })
      }

      stateUpd.uplineUsers = []
      if (isPermitted('u_upline_id')) {
        stateUpd.uplineUsers = this.state.uplineUsersList
          .filter(item => parseInt(item.id) === parseInt(stateUpd.userData['u_upline_id']))
          .map(item => {
            // 1. Identify the current division label/name.
            stateUpd.uplineCurrentValue = item.u_name

            // 2. Create dropdown item from division record.
            return {
              text: item.u_name,
              value: `${item.id}`,
              checked: true,
            }
          })
      }
    }

    this.setState(stateUpd)
    this.fetchUserDetails()
  }

  _fetchUserTypeHistory = async user_id => {
    return new Promise((resolve, reject) => {
      UserUserTypesService.history(user_id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  _fetchCurrentUserdata = async () => {
    return new Promise((resolve, reject) => {
      AdminApi.getProfileData(this.state.urlParams && this.state.urlParams.id ? this.state.urlParams.id : '')
        .then(async result => {
          if (result && result?.data?.access) {
            // Read-only (public-scope) profiles carry a stripped record — no
            // u_devision / recruited_by — so skip the recruiter + usertype-history
            // work entirely and render only the permitted attributes.
            if (result.data.access?.is_read_only === true) {
              const enableChangeUsertype = await this._determineCanChangeUsertype(result?.data?.data)

              this._loadProfile(
                result.data.data,
                result.data.access.permitted_attribs,
                result.data.imageUrl,
                enableChangeUsertype
              )
              return resolve()
            }

            const data = result?.data?.data,
              uplineForRecruiters =
                (data?.u_upline_id === data?.recruited_by && !data?.upline_can_recruit) || !data?.recruited_by
                  ? data?.u_upline_id
                  : data?.upline_upline_id || data?.u_upline_id
            const recruiters = this.buildRecruiterOptions(
              await this.fetchRecruiters(uplineForRecruiters, data.u_devision, data?.recruited_by),
              data?.recruited_by
            )

            this.setState({ recruiters })

            const usertypes_history = await this._fetchUserTypeHistory(result.data.data.id)

            result.data.data.usertypes_history = usertypes_history

            const enableChangeUsertype = await this._determineCanChangeUsertype(result?.data?.data)

            this._loadProfile(result.data.data, true, result.data.imageUrl, enableChangeUsertype)
            return resolve()
          }

          return reject()
        })
        .catch(error => {
          toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
          resolve()
        })
    })
  }

  fetchUserDetails = async () => {
    AdminApi.fetchUserDetailsAuth()
      .then(result => {
        if (result && result.data && result.data.data) {
          this.setState({ userRoles: result.data.data })
        }
      })
      .catch(error => {
        toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  _determineCanChangeUsertype = async userDetails => {
    // Revert to cached setting.
    if (this.state.enableChangeUsertype === true || this.state.enableChangeUsertype === false)
      return this.state.enableChangeUsertype

    // Limit option by level of access.
    // A. Permit all viable options if logged in user is an sys-admin.
    if (UserProfileService.isA(['system-admin'], true)) return true

    const accountUsertypeId = userDetails && userDetails?.usertype_id ? parseInt(userDetails?.usertype_id) : false

    // B. Permit all viable options if logged in user is an agency-owner.
    if (this._isAdminUser) {
      if (accountUsertypeId) return !['system-admin'].includes(UsertypeService.idToName(accountUsertypeId))
      return true
    }

    // C. Permit all viable options if logged in user is an BST admin.
    if (this._isBSTAdmin) return !['system-admin', 'agency-owner'].includes(UsertypeService.idToName(accountUsertypeId))

    // D. Check if the user-specific permission has been defined.
    if (this.state.permitChangeUsertype === true || this.state.permitChangeUsertype === false)
      return this.state.permitChangeUsertype

    return await this._checkCanChangeUsertypePermission().then(permitChangeUsertype => {
      this.setState({ permitChangeUsertype })
      return permitChangeUsertype
    })
  }

  _checkCanChangeUsertypePermission = async () => {
    if (this.state.permitChangeUsertype === null) {
      let permitChangeUsertype = false
      try {
        permitChangeUsertype = await UserProfileService.canUser('global.users.update-usertype')
      } catch (ex) {}
      return Promise.resolve(!!permitChangeUsertype)
    }

    return Promise.resolve(!!this.state.permitChangeUsertype)
  }

  _buildUserHistoryList = (usertype_history, commission_history, limit) => {
    const userNoteHistory = []
      .concat(
        Array.isArray(usertype_history)
          ? usertype_history.map(i => ({
              label: 'Usertype',
              text: `Set to ${i.displayname} by ${i.changed_by ? i.changed_by : (i.u_fname + ' ' + i.u_lname).trim()} ${
                i.change_trigger ? 'due to ' + i.change_trigger : ''
              }`,
              at: i.start_at,
            }))
          : []
      )
      .concat(
        Array.isArray(commission_history)
          ? commission_history.map(i => ({ label: 'Comm', text: i.text, at: i.at }))
          : []
      )

    const timestamp = entry => (entry.at ? new Date(entry.at).getTime() : 0)
    userNoteHistory.sort((a, b) => timestamp(b) - timestamp(a))

    if (!isNaN(limit)) {
      userNoteHistory.slice(0, limit)
    }

    return userNoteHistory.map(
      entry =>
        `<strong>${entry.label}:&nbsp;</strong>${entry.text}${
          entry.at ? ' on ' + moment(entry.at).format('MMMM D, YYYY h:mmA') : ''
        }`
    )
  }

  validate = async () => {
    const {
      u_address1,
      u_birthday,
      u_city,
      u_company_email,
      u_email,
      u_fax,
      u_fname,
      u_lname,
      u_mobile,
      u_phone,
      u_quote_email,
      u_state,
      u_timezone,
      u_tollfree,
      u_zip,
      u_marketing_title,
      u_login,
    } = this.state.userData

    if (!u_fname || !u_fname.trim()) {
      this.setState({ formError: true, errorMessage: 'First name required' })
      return
    }
    if (!u_lname || !u_lname.trim()) {
      this.setState({ formError: true, errorMessage: 'Last name required' })
      return
    }

    if (u_marketing_title && invalidMarketingTitles.includes(u_marketing_title.trim().toLowerCase())) {
      this.setState({
        formError: true,
        errorMessage: 'Invalid Marketing title',
      })
      return
    }

    if (!u_birthday) {
      this.setState({ formError: true, errorMessage: 'Birthdate Required' })
      return
    }

    if (!u_timezone) {
      this.setState({ formError: true, errorMessage: 'Timezone Required' })
      return
    }

    if (!u_email || !u_email.trim()) {
      this.setState({
        formError: true,
        errorMessage: 'Personal E-mail address required',
      })
      return
    }

    if (!emailPattern.test(u_email)) {
      this.setState({
        formError: true,
        errorMessage: 'Invalid E-mail format for personal E-mail',
      })
      return
    }

    if (u_company_email && !emailPattern.test(u_company_email)) {
      this.setState({
        formError: true,
        errorMessage: 'Invalid E-mail format for company E-mail',
      })
      return
    }

    if (u_quote_email && !emailPattern.test(u_quote_email)) {
      this.setState({
        formError: true,
        errorMessage: 'Invalid E-mail format for quote E-mail',
      })
      return
    }

    if (!u_phone || !u_phone.trim()) {
      this.setState({ formError: true, errorMessage: 'Phone number required' })
      return
    }

    if (!phonePattern.test(phoneToStorage(u_phone || ''))) {
      this.setState({ formError: true, errorMessage: 'Invalid Phone Number' })
      return
    }

    if (u_mobile && !phonePattern.test(phoneToStorage(u_mobile || ''))) {
      this.setState({ formError: true, errorMessage: 'Invalid Mobile Number' })
      return
    }

    if (u_tollfree && !phonePattern.test(phoneToStorage(u_tollfree || ''))) {
      this.setState({
        formError: true,
        errorMessage: 'Invalid Tollfree Number',
      })
      return
    }

    if (u_fax && !phonePattern.test(phoneToStorage(u_fax || ''))) {
      this.setState({ formError: true, errorMessage: 'Invalid Fax Number' })
      return
    }

    if (!u_address1 || !u_address1.trim()) {
      this.setState({ formError: true, errorMessage: 'Address required' })
      return
    }

    if (!u_city || !u_city.trim()) {
      this.setState({ formError: true, errorMessage: 'City required' })
      return
    }

    if (!u_state) {
      this.setState({ formError: true, errorMessage: 'State required' })
      return
    }

    if (!u_zip || !u_zip.trim()) {
      this.setState({ formError: true, errorMessage: 'Zip required' })
      return
    }

    if (
      !UserProfileService.isA([
        'affiliate-group',
        'associate-group',
        'internal-admin',
        'internal-staff',
        'system-admin',
        'division-admin',
        'region-admin',
        'district-admin',
      ]) &&
      (!u_login || !u_login.trim())
    ) {
      this.setState({ formError: true, errorMessage: 'Subsite Link required' })
      return
    }

    this.setState({ formError: false, errorMessage: '' })
  }

  handleUpdate = async (confirmedLegalName = false) => {
    await this.validate()
    const { formError, errorMessage, loading } = this.state
    const {
      u_nickname,
      npn,
      u_address1,
      u_address2,
      u_birthday,
      u_city,
      u_company_email,
      u_email,
      u_fax,
      u_fname,
      u_lname,
      u_name_pronunciation,
      u_marketing_title,
      u_mobile,
      u_notes_admin,
      u_private_notes,
      u_phone,
      u_quote_email,
      u_state,
      recruited_by,
      u_timezone,
      u_tollfree,
      u_upline_id,
      u_spoken_language,
      u_zip,
      usertype_id,
      commission_id,
      u_login,
    } = this.state.userData

    if (loading) {
      return
    }
    if (formError) {
      toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT })
      return
    }

    const isLegalNameChanged =
      (u_fname && u_fname.trim() !== this.state.clonedUserData.u_fname) ||
      (u_lname && u_lname.trim() !== this.state.clonedUserData.u_lname)

    if (isLegalNameChanged && !confirmedLegalName) {
      this.setState({ legalNameModal: true })
      return
    }

    const data = {}

    if (u_fname && u_fname.trim() !== this.state.clonedUserData.u_fname) {
      data['u_fname'] = u_fname.trim()
    }
    if (u_lname && u_lname.trim() !== this.state.clonedUserData.u_lname) {
      data['u_lname'] = u_lname.trim()
    }
    if (u_name_pronunciation && u_name_pronunciation.trim() !== this.state.clonedUserData.u_name_pronunciation) {
      data['u_name_pronunciation'] = u_name_pronunciation.trim()
    }
    if (u_marketing_title && u_marketing_title.trim() !== this.state.clonedUserData.u_marketing_title) {
      data['u_marketing_title'] = u_marketing_title.trim()
    }
    if (npn && npn.trim() !== this.state.clonedUserData.npn) {
      data['npn'] = npn.trim()
    }
    if (usertype_id && usertype_id !== this.state.clonedUserData.usertype_id) {
      data['usertype_id'] = usertype_id
    }

    if (commission_id && commission_id !== this.state.clonedUserData.commission_id) {
      data['commission_id'] = commission_id
    }

    if (u_upline_id && u_upline_id !== this.state.clonedUserData.u_upline_id) {
      data['u_upline_id'] = u_upline_id
    }

    if (u_birthday !== this.state.clonedUserData.u_birthday) {
      data['u_birthday'] = moment(u_birthday).format('YYYY-MM-DD')
    }
    if (u_timezone !== this.state.clonedUserData.u_timezone) {
      data['u_timezone'] = u_timezone
    }
    if (`${u_nickname}`.trim() !== `${this.state.clonedUserData.u_nickname}`.trim()) {
      data['u_nickname'] = u_nickname.trim()
    }
    if (u_email && u_email.trim() !== this.state.clonedUserData.u_email) {
      data['u_email'] = u_email.trim()
    }
    if (
      (u_company_email && u_company_email.trim() !== this.state.clonedUserData.u_company_email) ||
      (!u_company_email && this.state.clonedUserData.u_company_email)
    ) {
      data['u_company_email'] = u_company_email.trim()
    }
    if (
      (u_quote_email && u_quote_email.trim() !== this.state.clonedUserData.u_quote_email) ||
      (!u_quote_email && this.state.clonedUserData.u_quote_email)
    ) {
      data['u_quote_email'] = u_quote_email.trim()
    }

    if (
      (u_phone && u_phone.trim() !== this.state.clonedUserData.u_phone) ||
      (!u_phone && this.state.clonedUserData.u_phone)
    ) {
      if (phoneToStorage(u_phone || '') !== phoneToStorage(this.state.clonedUserData.u_phone || ''))
        data['u_phone'] = phoneToStorage(u_phone)
    }

    if (
      (u_mobile && u_mobile.trim() !== this.state.clonedUserData.u_mobile) ||
      (!u_mobile && this.state.clonedUserData.u_mobile)
    ) {
      if (phoneToStorage(u_mobile || '') !== phoneToStorage(this.state.clonedUserData.u_mobile || ''))
        data['u_mobile'] = phoneToStorage(u_mobile)
    }

    if (
      (u_tollfree && u_tollfree.trim() !== this.state.clonedUserData.u_tollfree) ||
      (!u_tollfree && this.state.clonedUserData.u_tollfree)
    ) {
      if (phoneToStorage(u_tollfree || '') !== phoneToStorage(this.state.clonedUserData.u_tollfree || ''))
        data['u_tollfree'] = phoneToStorage(u_tollfree)
    }

    if ((u_fax && u_fax.trim() !== this.state.clonedUserData.u_fax) || (!u_fax && this.state.clonedUserData.u_fax)) {
      if (phoneToStorage(u_fax || '') !== phoneToStorage(this.state.clonedUserData.u_fax || ''))
        data['u_fax'] = phoneToStorage(u_fax)
    }

    if (u_address1 && u_address1.trim() !== this.state.clonedUserData.u_address1) {
      data['u_address1'] = u_address1.trim()
    }
    if (u_address2 && u_address2.trim() !== this.state.clonedUserData.u_address2) {
      data['u_address2'] = u_address2.trim()
    }
    if (u_city && u_city.trim() !== this.state.clonedUserData.u_city) {
      data['u_city'] = u_city.trim()
    }
    if (u_state !== this.state.clonedUserData.u_state) {
      data['u_state'] = u_state
    }
    if (recruited_by !== this.state.clonedUserData.recruited_by) {
      data['recruited_by'] = recruited_by
    }
    if (u_zip && u_zip.trim() !== this.state.clonedUserData.u_zip) {
      data['u_zip'] = u_zip.trim()
    }
    if (u_notes_admin && u_notes_admin.trim() !== this.state.clonedUserData.u_notes_admin) {
      data['u_notes_admin'] = u_notes_admin.trim()
    }

    if (u_private_notes && u_private_notes.trim() !== this.state.clonedUserData.u_private_notes) {
      data['u_private_notes'] = u_private_notes.trim()
    }
    if (u_spoken_language.length) {
      data['u_spoken_language'] = JSON.stringify(u_spoken_language)
    }
    if (u_login && u_login.trim() !== this.state.clonedUserData.u_login) {
      data['u_login'] = u_login.trim()
    }

    if (data.constructor !== Object || !Object.keys(data).length)
      return toast.error('Please change some values!', {
        position: toast.POSITION.TOP_RIGHT,
      })

    data.u_changed = UserProfileService.getUserId(this._isAssumedUser)
    data.u_changed_name = [
      UserProfileService.get('u_fname', this._isAssumedUser),
      UserProfileService.get('u_lname', this._isAssumedUser),
    ]
      .join(' ')
      .trim()
    data.id = this.state.userRoles.id

    const form_data = new FormData()
    for (let key in data) form_data.append(key, data[key])
    form_data.append('is_manual', true)

    this.updateProfile(form_data, false).then(updates => {
      Object.keys(data)
        .filter(k => ['id', 'u_changed', 'u_changed_name'].indexOf(k) < 0 && typeof updates[k] !== 'undefined')
        .forEach(k => UserProfileService.set(k, updates[k]))
    })
  }

  updateProfile = async (data, pageReload) => {
    this.setState({ submitting: true })

    return new Promise((resolve, reject) => {
      AdminApi.updateProfile(data)
        .then(result => {
          this.setState({
            loading: true,
            submitting: false,
            u_fname: '',
            u_lname: '',
            u_name_pronunciation: '',
            u_timezone: '',
            u_marketing_title: '',
            usertype_id: 0,
            u_active: '',
            u_email: '',
            u_address1: '',
            u_address2: '',
            u_city: '',
            u_state: '',
            recruited_by: '',
            u_zip: '',
            commission_id: 0,
            u_upline_id: 0,
            u_birthday: new Date(),
            u_enrolled: new Date(),
            u_devision: 0,
            u_picture: '',
            divisionAutoSetFromUpline: false,
            divisionSyncing: false,
          })

          toast.success('User updated successfully', {
            position: toast.POSITION.TOP_RIGHT,
          })

          const divisionSync = result?.data?.divisionSync
          if (divisionSync && divisionSync.name)
            toast.info(`Division saved as ${divisionSync.name} to match the new upline leader.`, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 8000,
            })

          this._fetchCurrentUserdata().finally(() => {
            resolve(result?.data?.data || {})
            this.setState({ loading: false })
          })
        })
        .catch(error => {
          this.setState({ submitting: false })
          toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
          reject(error)
        })
    })
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab })
  }

  renderProfileCard() {
    const { submitting, isReadOnly } = this.state
    const {
      u_nickname,
      npn,
      u_address1,
      u_address2,
      u_city,
      u_company_email,
      u_email,
      u_fax,
      u_fname,
      u_lname,
      u_name_pronunciation,
      u_marketing_title,
      u_mobile,
      u_phone,
      u_quote_email,
      u_state,
      u_timezone,
      u_tollfree,
      u_zip,
      u_login,
      recruited_by,
    } = this.state.userData

    const u_birthday = this.state.userData.u_birthday || null

    switch (this.state.activeTab) {
      case 'my-profile':
        return (
          <form className={`agent-profile-form ${isReadOnly ? 'read-only' : ''}`}>
            <div className='form-row'>
              {!isReadOnly || this._isPermitted('u_fname') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='Legal First Name'
                    group
                    type='text'
                    name='u_fname'
                    value={u_fname || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_lname') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='Legal Last Name'
                    group
                    type='text'
                    name='u_lname'
                    value={u_lname || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_name_pronunciation') ? (
                <div className='form-group col-md-6 has-helper-link'>
                  <UIInput
                    label='Name pronunciation'
                    group
                    type='text'
                    name='u_name_pronunciation'
                    onChange={this.onChange}
                    value={u_name_pronunciation || ''}
                    validate
                    readOnly={isReadOnly}
                    maxLength='128'
                  />
                  <small className='text-left helper-link'>
                    Not sure how to pronounce?{' '}
                    <a
                      href={`${appConstants.name_pronunciation_link_prefix}${
                        u_name_pronunciation || `${u_fname?.toLowerCase()}-${u_lname?.toLowerCase()}`
                      }`}
                      target='_BLANK'
                      rel='noopener noreferrer'
                    >
                      Click here to hear it!
                    </a>
                  </small>
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_marketing_title') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='Marketing Title'
                    group
                    type='text'
                    name='u_marketing_title'
                    value={u_marketing_title || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={
                      isReadOnly ||
                      UserProfileService.isA(['career-agent']) ||
                      parseInt(this.state.userData['usertype_id']) === appConstants.career_agent
                    }
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('npn') ? (
                <div className='form-group col-md-6 has-helper-link'>
                  <UIInput
                    label='NPN Number'
                    group
                    type='text'
                    name='npn'
                    value={npn || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                  <small className='text-left helper-link'>
                    Misplaced NPN number?{' '}
                    <a href='https://nipr.com/help/look-up-your-npn' target='_BLANK' rel='noopener noreferrer'>
                      Look it up here!
                    </a>
                  </small>
                </div>
              ) : (
                <></>
              )}
              {(!isReadOnly || this._isPermitted('u_login')) && this._isStaffUser ? (
                <div className='form-group col-md-6 has-helper-link'>
                  <UIInput
                    label='Subsite Link'
                    group
                    type='text'
                    name='u_login'
                    value={u_login || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {(!isReadOnly || this._isPermitted('recruited_by')) && this._isStaffUser ? (
                <div className='form-group col-md-6 has-helper-link'>
                  <UISelect
                    options={this.state.recruiters || []}
                    value={recruited_by || ''}
                    getValue={selectedOption => {
                      this.onRecruiterChange(selectedOption.value)
                    }}
                    label='Recruited By'
                    disabled={isReadOnly}
                    preventFirstSelection
                  />
                </div>
              ) : (
                <></>
              )}
              {this._isAssumedUser || isReadOnly || this._isStaffUser ? (
                <>
                  {!isReadOnly || this._isPermitted('usertype_id') ? (
                    <div className='form-group col-md-6'>
                      {this._isStaffUser && this.state.enableChangeUsertype ? (
                        <UISelect
                          disabled={
                            !this.state.enableChangeUsertype || !(this._isAdminUser || this._isBSTAdmin) || isReadOnly
                          }
                          options={this.state.userTypes || []}
                          value={this.state.userData['usertype_id'] || ''}
                          getValue={selectedOption => {
                            this.onUserTypeChange(selectedOption.value)
                          }}
                          label='Usertype'
                        />
                      ) : (
                        <UIInput
                          readonly={!this.state.enableChangeUsertype}
                          disabled={!(this._isAdminUser || this._isBSTAdmin)}
                          label='Usertype'
                          type='text'
                          name='usertype_id'
                          value={this.state.userTypeCurrentValue || ''}
                        />
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                  {!isReadOnly || this._isPermitted('commission_id') ? (
                    <div className='form-group col-md-6'>
                      {(this._isStaffUser || this._isLeaderOrAssitUser) &&
                      !(!!this.state.Cart && this._isLeaderOrAssitUser) ? (
                        <UISelect
                          disabled={isReadOnly}
                          options={this.state.commissionLevels || []}
                          value={this.state.userData['commission_id'] || ''}
                          getValue={selectedOption => {
                            this.onCommissionLevelChange(selectedOption.value)
                          }}
                          label='Commission Level'
                        />
                      ) : (
                        <UIInput
                          disabled={true}
                          label='Commission Level'
                          type='text'
                          name='commission_id'
                          value={this.state.commissionLevelCurrentValue || ''}
                        />
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                  {!isReadOnly || this._isPermitted('u_devision') ? (
                    <div className='form-group col-md-6'>
                      {this.state.divisionSyncing ? (
                        <div className='md-form text-muted'>
                          <MDBIcon icon='spinner' spin className='mr-2' />
                          Updating Division from the selected upline leader...
                        </div>
                      ) : (
                        <UIInput
                          disabled={true}
                          label='Division'
                          type='text'
                          name='division_id'
                          value={this.state.divisionCurrentValue || ''}
                        />
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                  {this._canSetUpline ? (
                    <div className='form-group col-md-6'>
                      <UISelect
                        search
                        options={this.state.uplineUsers || []}
                        value={this.state.userData['u_upline_id'] || ''}
                        getValue={selectedOption => {
                          this.onUplineChange(selectedOption.value)
                        }}
                        label='Upline Leader'
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_birthday') ? (
                <div className='form-group col-md-6'>
                  <div className='md-form'>
                    <UIDatePickerInput
                      label='Date of Birth'
                      name='u_birthday'
                      id='dp_u_birthday'
                      showYearDropdown
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown
                      dateFormat='MM/dd/yyyy'
                      maxDate={this.maxDob}
                      selected={u_birthday}
                      onChange={date => this.onDateChange(date?.target?.value)}
                      readOnly={isReadOnly}
                    />
                  </div>
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_nickname') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='Nickname'
                    group
                    type='text'
                    name='u_nickname'
                    value={u_nickname || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_email') ? (
                <div className='form-group col-md-6 has-helper-link'>
                  <MDBInput
                    label={
                      isReadOnly ? (
                        'Personal E-mail (Login)'
                      ) : (
                        <ToolTip
                          tag='span'
                          label={'Personal E-mail (Login)'}
                          content={'This is your personal email used to login and to identify your account.'}
                        />
                      )
                    }
                    group
                    type='text'
                    name='u_email'
                    value={u_email || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                  {isWhiteLabel() ? (
                    <></>
                  ) : (
                    <small className='text-left helper-link'>
                      <MDBIcon icon='exclamation-circle' />
                      &nbsp;USABG will email you using this email address.
                    </small>
                  )}
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_company_email') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label={
                      isReadOnly ? (
                        'Company E-mail'
                      ) : (
                        <ToolTip
                          tag='span'
                          label={'Company E-mail'}
                          content={
                            'This is commonly your USABG corporate email and is the default email for your subsite.  If not set, your subsite will use your Personal Email.'
                          }
                        />
                      )
                    }
                    group
                    type='text'
                    name='u_company_email'
                    value={u_company_email || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_quote_email') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label={
                      isReadOnly ? (
                        'Quote E-mail'
                      ) : (
                        <ToolTip
                          tag='span'
                          label={'Quote E-mail'}
                          content={
                            "This is the default email for your subsite Quote & Contact submission forms.  If not set, we'll use your Personal Email."
                          }
                        />
                      )
                    }
                    group
                    type='text'
                    name='u_quote_email'
                    value={u_quote_email || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_timezone') ? (
                <div className='form-group col-md-6'>
                  <UISelect
                    options={this.state.timezones || []}
                    value={u_timezone || ''}
                    getValue={selectedOption => {
                      this.onTimezoneChange(selectedOption.value)
                    }}
                    label='Timezone'
                    disabled={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_phone') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='Phone Number'
                    group
                    type='text'
                    name='u_phone'
                    value={u_phone || ''}
                    onBlur={evt => this.onChange(evt, 'phone')}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_mobile') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='Mobile Number'
                    group
                    type='text'
                    name='u_mobile'
                    value={u_mobile || ''}
                    onBlur={evt => this.onChange(evt, 'phone')}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_tollfree') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='Toll Free'
                    group
                    type='text'
                    name='u_tollfree'
                    value={u_tollfree || ''}
                    onBlur={evt => this.onChange(evt, 'phone')}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_fax') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='Fax Number'
                    group
                    type='text'
                    name='u_fax'
                    value={u_fax || ''}
                    onBlur={evt => this.onChange(evt, 'phone')}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_address1') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='Address 1'
                    group
                    type='text'
                    name='u_address1'
                    value={u_address1 || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_address2') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='Address 2'
                    group
                    type='text'
                    name='u_address2'
                    value={u_address2 || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_city') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='City'
                    group
                    type='text'
                    name='u_city'
                    value={u_city || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_state') ? (
                <div className='form-group col-md-6'>
                  <UISelect
                    options={this.state.states || []}
                    value={u_state || ''}
                    getValue={selectedOption => {
                      this.onStatesChange(selectedOption.value)
                    }}
                    label='State'
                    disabled={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('u_zip') ? (
                <div className='form-group col-md-6'>
                  <UIInput
                    label='Zip'
                    group
                    type='text'
                    name='u_zip'
                    value={u_zip || ''}
                    onChange={this.onChange}
                    validate
                    readOnly={isReadOnly}
                  />
                </div>
              ) : (
                <></>
              )}
              {!isReadOnly || this._isPermitted('spoken_language') ? (
                <div className='form-group col-md-6'>
                  {isReadOnly ? (
                    <MDBInput
                      label='Spoken Language'
                      type='text'
                      value={
                        Array.isArray(this.state.userData.u_spoken_language)
                          ? this.state.userData.u_spoken_language.join(', ')
                          : this.state.userData.u_spoken_language || ''
                      }
                      readOnly={true}
                    />
                  ) : (
                    <MDBSelect
                      multiple
                      label='Spoken Language'
                      disabled={isReadOnly}
                      data={(this.state.spokenLanguages || []).map(option => ({
                        text: option.text,
                        value: option.value,
                        defaultSelected: (this.state.userData.u_spoken_language || []).includes(option.value),
                      }))}
                      onValueChange={selected =>
                        this.onSpokenLanguageChange(
                          (Array.isArray(selected) ? selected : [selected]).filter(Boolean).map(o => o.value)
                        )
                      }
                    />
                  )}
                </div>
              ) : (
                <></>
              )}
            </div>
            {!isReadOnly ? (
              <div className='text-center mb-4 mt-5'>
                <MDBBtn
                  color='danger'
                  type='button'
                  className='btn-block z-depth-2'
                  onClick={() => this.handleUpdate()}
                >
                  {submitting ? 'Saving...' : 'Save Profile'}
                </MDBBtn>
              </div>
            ) : (
              <></>
            )}
          </form>
        )
      case 'agent-options':
        return <AgentOptions />
      case 'agent-requirements':
        return <AgentRequirements userId={UserProfileService.getUserId()} />
      case 'notifications':
        // Guarded again here, not just on the tab: activeTab is state, and a
        // tab that is never rendered should still never render its panel.
        return this._canSendPush ? (
          <AgentPushMessage
            agentId={this.state.userData.id}
            // The recipient's identity must come from the agent record this
            // page loaded (_fetchCurrentUserdata resolves it from the :id
            // param, or the assumed user). The card cannot derive it from
            // UserProfileService — that returns the admin on /:id/... .
            agentName={[this.state.userData.u_fname, this.state.userData.u_lname].filter(Boolean).join(' ').trim()}
            agentEmail={this.state.userData.u_email}
          />
        ) : null
      default:
        break
    }
  }

  render() {
    toast.configure()
    const { activeTab, loading, notesHistoryList, isReadOnly } = this.state
    const { id } = this.state.userData

    return (
      <Fragment>
        <DashboardLayout>
          <main id='AccountProfilePage' className='mainSection'>
            <LegalNameChangeModal
              open={this.state.legalNameModal}
              onConfirm={this._confirmLegalNameChange}
              onCancel={this._cancelLegalNameChange}
            />
            <MDBModal open={this.state.userTermsModal} onClose={this._toggleUserTermsModal}>
              <MDBModalDialog size='xl'>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBBtn
                      type='button'
                      className='btn-close'
                      color='none'
                      onClick={this._toggleUserTermsModal}
                    ></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <AgentTerms userId={id} hideHeader={true} />
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
            <h2>Account Profile</h2>
            <hr />
            {loading ? (
              <h2>Loading...</h2>
            ) : (
              <MDBRow>
                {/* <!-- Main Column --> */}
                <MDBCol lg='8' className='mb-3'>
                  <MDBCard>
                    <MDBCardHeader className='indigo'>
                      {this._isStaffUser ? (
                        <>
                          <span
                            className={`profile-tab ${activeTab === 'my-profile' ? 'active' : ''}`}
                            onClick={e => this.toggleTab('my-profile')}
                          >
                            My Profile
                          </span>
                          <span
                            className={`profile-tab ${activeTab === 'agent-requirements' ? 'active' : ''}`}
                            onClick={e => this.toggleTab('agent-requirements')}
                          >
                            Agent Requirements
                          </span>
                          <span
                            className={`profile-tab ${activeTab === 'agent-options' ? 'active' : ''}`}
                            onClick={e => this.toggleTab('agent-options')}
                          >
                            Agent Options
                          </span>
                          {this._canSendPush && (
                            <span
                              className={`profile-tab ${activeTab === 'notifications' ? 'active' : ''}`}
                              onClick={e => this.toggleTab('notifications')}
                            >
                              Notifications
                            </span>
                          )}
                        </>
                      ) : (
                        'My Profile'
                      )}
                    </MDBCardHeader>
                    <MDBCardBody className='mx-4 mt-4'>{this.renderProfileCard()}</MDBCardBody>
                  </MDBCard>
                  {!isReadOnly && id && (
                    <MDBCard>
                      <MDBCardHeader className='indigo'>Notes</MDBCardHeader>
                      <MDBCardBody>
                        <AgentNotes></AgentNotes>
                      </MDBCardBody>
                    </MDBCard>
                  )}
                </MDBCol>

                {/* <!-- Right Hand Column --> */}
                <MDBCol lg='4'>
                  <MDBCard className='testimonial-card'>
                    <MDBCardHeader className='indigo'>Profile Photo & Details</MDBCardHeader>
                    <MDBCardBody>
                      <h4 className='card-title'>
                        {!!this.state.clonedUserData.u_fname ? this.state.clonedUserData.u_fname : ''}{' '}
                        {!!this.state.clonedUserData.u_lname ? this.state.clonedUserData.u_lname : ''}
                      </h4>
                      <hr />
                      <AgentHeadshotUploader
                        layout={'portrait'}
                        isReadOnly={isReadOnly}
                        isPermitted={this._isPermitted('profile_pic')}
                      />
                      <hr />
                      <MDBListGroup>
                        {this._isStaffUser ? (
                          <MDBListGroupItem style={{ backgroundColor: 'rgba(220,220,220,0.8)' }}>
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: '500',
                                color: 'rgba(120,120,120,0.6)',
                                textAlign: 'center',
                              }}
                            >
                              USABG STAFF ONLY - PRIVATE
                            </div>
                            <div
                              style={{
                                fontSize: '14px',
                                fontWeight: '500',
                                color: 'rgba(120,120,120,0.8)',
                                textAlign: 'center',
                              }}
                            >
                              <b>User ID:</b> {!!this.state.clonedUserData.id ? this.state.clonedUserData.id : ''}
                            </div>
                            <AgentCorporateEmailLink userId={this.state.clonedUserData?.id} />
                          </MDBListGroupItem>
                        ) : (
                          <></>
                        )}
                        {!isReadOnly || this._isPermitted('u_email') ? (
                          <MDBListGroupItem>
                            <b>Login:</b>{' '}
                            {!!this.state.clonedUserData.u_email ? this.state.clonedUserData.u_email : 'N/A'}
                          </MDBListGroupItem>
                        ) : (
                          <></>
                        )}
                        {!isReadOnly || this._isPermitted('displayname') ? (
                          <MDBListGroupItem>
                            <b>Account Type:</b>{' '}
                            {!!this.state.clonedUserData.displayname ? this.state.clonedUserData.displayname : 'N/A'}
                          </MDBListGroupItem>
                        ) : (
                          <></>
                        )}
                        {!isReadOnly || this._isPermitted('d_name') ? (
                          <MDBListGroupItem>
                            <b>Division:</b>{' '}
                            {!!this.state.clonedUserData.d_name ? this.state.clonedUserData.d_name : 'N/A'}
                          </MDBListGroupItem>
                        ) : (
                          <></>
                        )}
                        {!isReadOnly || this._isPermitted('com_name') ? (
                          <MDBListGroupItem>
                            <b>Commission Level:</b>{' '}
                            {!!this.state.clonedUserData.com_name ? this.state.clonedUserData.com_name : 'N/A'}
                          </MDBListGroupItem>
                        ) : (
                          <></>
                        )}
                        {!isReadOnly || this._isPermitted('upline_fname') || this._isPermitted('upline_lname') ? (
                          <MDBListGroupItem>
                            <b>Upline Leader:</b>{' '}
                            {!!this.state.clonedUserData.upline_fname ? this.state.clonedUserData.upline_fname : ''}{' '}
                            {!!this.state.clonedUserData.upline_lname ? this.state.clonedUserData.upline_lname : ''}{' '}
                            {!this.state.clonedUserData.upline_fname && !this.state.clonedUserData.upline_lname
                              ? 'N/A'
                              : ''}
                          </MDBListGroupItem>
                        ) : (
                          <></>
                        )}
                        {!isReadOnly || this._isPermitted('u_enrolled') ? (
                          <MDBListGroupItem>
                            <b>Enrollment Date:</b>{' '}
                            {!!this.state.clonedUserData.u_enrolled
                              ? moment(this.state.clonedUserData.u_enrolled).format('MM/DD/YYYY')
                              : 'N/A'}
                          </MDBListGroupItem>
                        ) : (
                          <></>
                        )}
                        {!isReadOnly || this._isPermitted('u_active') ? (
                          <MDBListGroupItem>
                            <b>Account Status:</b> {!!this.state.clonedUserData.u_active ? 'Active' : 'Inactive'}
                          </MDBListGroupItem>
                        ) : (
                          <></>
                        )}
                        {!isReadOnly || this._isPermitted('u_lastlogin') ? (
                          <MDBListGroupItem>
                            <b>Last Login:</b>{' '}
                            {!!this.state.clonedUserData.u_lastlogin
                              ? moment(this.state.clonedUserData.u_lastlogin).format('llll')
                              : 'N/A'}
                          </MDBListGroupItem>
                        ) : (
                          <></>
                        )}
                        {!isReadOnly || this._isPermitted('created_at') ? (
                          <MDBListGroupItem>
                            <b>Account Created:</b>{' '}
                            {!!this.state.clonedUserData.created_at
                              ? moment(this.state.clonedUserData.created_at).format('llll')
                              : 'N/A'}
                          </MDBListGroupItem>
                        ) : (
                          <></>
                        )}
                      </MDBListGroup>
                      {!isReadOnly &&
                      localUserData &&
                      [35, 36, 219, 222].includes(JSON.parse(localUserData).usertype_id) ? (
                        <div className='text-center' style={{ marginTop: '1rem' }}>
                          <MDBBtn
                            type='button'
                            color='primary'
                            className='btn-block'
                            onClick={() => this._toggleUserTermsModal()}
                          >
                            View User&apos;s Accepted Terms
                          </MDBBtn>
                        </div>
                      ) : (
                        <></>
                      )}
                    </MDBCardBody>
                  </MDBCard>
                  {this._canViewHistory() ? (
                    <>
                      <MDBCard className='mt-5 mb-5 user-history'>
                        <MDBCardHeader className='indigo'>Usertype & Commission Level History</MDBCardHeader>
                        <MDBCardBody className='mx-4 mt-4'>
                          <CustomAlert color='danger' className='no-agents-alert'>
                            Note: Historical information is only visible to Leaders.{' '}
                            <strong>Agents can not see this history.</strong>
                          </CustomAlert>
                          <MDBListGroup>
                            {notesHistoryList && notesHistoryList.length ? (
                              notesHistoryList.map((item, i) => {
                                return (
                                  <MDBListGroupItem
                                    key={i}
                                    dangerouslySetInnerHTML={{ __html: item }}
                                  ></MDBListGroupItem>
                                )
                              })
                            ) : (
                              <MDBListGroupItem>No agent notes on record.</MDBListGroupItem>
                            )}
                          </MDBListGroup>
                        </MDBCardBody>
                      </MDBCard>
                      <div className='mb-3'>
                        <RequiredTrainingChart />
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  {!isReadOnly ? (
                    <>
                      <div className='mb-3'>
                        <ResetEnrollmentButton
                          onReset={res => {
                            if (res) {
                              if (res === true)
                                toast.success("Agent's enrollment date has been updated to today.", {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                              else if (res)
                                toast.error(res, {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                            }
                          }}
                        />
                      </div>
                      <div className='mb-3'>
                        <ResyncCorporateEmailButton
                          onResync={res => {
                            if (res) {
                              if (res === 'resync')
                                toast.success(
                                  "Agent's corporate email has been re-synced & instructional email sent.",
                                  { position: toast.POSITION.TOP_RIGHT }
                                )
                              else if (res === 'delete')
                                toast.success("Agent's corporate email has been deleted.", {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                              else if (res)
                                toast.error(res, {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                            }
                          }}
                        />
                      </div>
                      <div className='mb-3'>
                        <AddAdminFeeWaiverButton
                          onWaived={res => {
                            if (res) {
                              if (res === true)
                                toast.success("Agent's subscription admin fee has been waived for today.", {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                              else if (res)
                                toast.error(res, {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                            }
                          }}
                        />
                      </div>
                      <div className='mb-3'>
                        <ResetUplineSignatureButton
                          onReset={res => {
                            if (res) {
                              if (res === true) {
                                toast.success("Agent's upline signature has been updated.", {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                              } else if (res)
                                toast.error(res, {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                            }
                          }}
                        />
                      </div>
                      <div className='mb-3'>
                        <ViewAwardButton />
                      </div>
                      <div className='mb-3'>
                        <ResendEmailButton />
                      </div>
                      <div className='mb-3'>{this._renderRecruitingPermissionToggle()}</div>
                      <div className='mb-3'>
                        <ChangeRequestButton userId={UserProfileService.getUserId()} />
                      </div>
                      <div className='mb-3'>
                        <SupportEmailsModal
                          userId={UserProfileService.getUserId()}
                          buttonLabel='Manage Support Emails'
                          buttonClassName='btn-block'
                          buttonColor='danger'
                        />
                      </div>
                      <div className='mb-3'>
                        <UserActiveButton
                          onChange={res => {
                            if (res) {
                              if (res === true) {
                                let changeTo = ''
                                switch (parseInt(UserProfileService.get('u_active'))) {
                                  case 1:
                                    changeTo = 'Active'
                                    break
                                  case 0:
                                    changeTo = 'Deactivated'
                                    break
                                  case -1:
                                    changeTo = 'Protected'
                                    break
                                  case -2:
                                    changeTo = 'Blacklisted'
                                    break
                                  default:
                                    return ''
                                }

                                toast.success(`Agent's account active status has been changed to '${changeTo}'.`, {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                              } else if (res)
                                toast.error(res, {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                            }
                          }}
                        />
                      </div>
                      <div className='mb-3'>
                        <HasOnboardedToggleSwitch
                          onToggle={res => {
                            if (res) {
                              if (res === true)
                                toast.success('Success.  Agent has completed onboarding.', {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                              else if (res === false)
                                toast.success('Success.  Agent has NOT completed onboarding.', {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                              else if (res)
                                toast.error(res, {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                            }
                          }}
                        />
                      </div>
                      <div className='mb-3'>
                        <IsTeamRecruiterToggleSwitch
                          onToggle={res => {
                            if (res) {
                              if (res === true)
                                toast.success('Success.  Agent is setup as a Team Recruiter.', {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                              else if (res === false)
                                toast.success('Success.  Agent is NOT setup as a Team Recruiter.', {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                              else if (res)
                                toast.error(res, {
                                  position: toast.POSITION.TOP_RIGHT,
                                })
                            }
                          }}
                        />
                      </div>
                      <div className='mb-3'>
                        <UpdatePaymentToggleSwitch
                          onToggle={res => {
                            if (res === true)
                              toast.success('Success.  Enable to show update payment method modal', {
                                position: toast.POSITION.TOP_RIGHT,
                              })
                            else if (res === false)
                              toast.success('Success.  Disable to show update payment method modal', {
                                position: toast.POSITION.TOP_RIGHT,
                              })
                            else if (res)
                              toast.error(res, {
                                position: toast.POSITION.TOP_RIGHT,
                              })
                          }}
                        />
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  {isReadOnly && !this._isStaffUser ? (
                    <div className='mb-3'>{this._renderRecruitingPermissionToggle()}</div>
                  ) : (
                    <></>
                  )}
                </MDBCol>
              </MDBRow>
            )}
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default AccountProfile
